import React from 'react';
import Box from '@mui/material/Box';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { CHAT_FILE_TYPE_ICONS } from './chatFileTypeAssets';

export type ChatPdfDocumentTileProps = {
  size?: number;
};

/**
 * PDF tile for chat — white background + red PDF branding, no page preview.
 * Never falls back to the generic image landscape placeholder.
 */
const ChatPdfDocumentTile: React.FC<ChatPdfDocumentTileProps> = ({ size = 110 }) => {
  const [useMuiFallback, setUseMuiFallback] = React.useState(false);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        bgcolor: 'common.white',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        flexShrink: 0,
      }}
    >
      {useMuiFallback ? (
        <PictureAsPdfOutlinedIcon sx={{ fontSize: size * 0.45, color: 'error.main' }} aria-hidden />
      ) : (
        <Box
          component="img"
          src={CHAT_FILE_TYPE_ICONS.pdf}
          alt=""
          onError={() => setUseMuiFallback(true)}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      )}
    </Box>
  );
};

export default ChatPdfDocumentTile;
